/**
 * The prompt editor is a Radix Sheet (Dialog). Nested Dialog / Popover content
 * portals to document.body, so a click inside Duplicate/Delete (or their
 * tenant combobox) looks like an outside interaction and would dismiss the
 * drawer underneath — and with it, any dialog still mounted inside the sheet.
 */
const KEEP_PROMPT_EDITOR_OPEN_SELECTORS = [
  '[data-slot="dialog-content"]',
  '[data-slot="dialog-overlay"]',
  "[data-radix-popper-content-wrapper]",
  "[role='dialog']",
  "[role='alertdialog']",
] as const;

export function shouldKeepPromptEditorOpen(target: EventTarget | null): boolean {
  if (!(target instanceof Element)) return false;
  return KEEP_PROMPT_EDITOR_OPEN_SELECTORS.some(
    (selector) => target.closest(selector) !== null,
  );
}
